//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Object.js";
import "../no/GeometricUtilities.js";
import "../no/ugmath.js";
import "../Features/Features.Subdivision.SubdivisionBodyCollection.js";
let d=[[],[[["data","origin","matrix"],"Locate",{},1,0]],[]];
SPLM.Features.Subdivision.TransformerLocator = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Features.Subdivision.TransformerLocator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.TransformerLocator.Data = class{
    constructor(entity,cursorLocation,viewDirection,snapToLocation,activeObjectType,hasPlanarConfiguration,canRelocate,canReorient,distanceTolerance){
        this.entity=entity;this.cursorLocation=cursorLocation;this.viewDirection=viewDirection;this.snapToLocation=snapToLocation;this.activeObjectType=activeObjectType;this.hasPlanarConfiguration=hasPlanarConfiguration;this.canRelocate=canRelocate;this.canReorient=canReorient;this.distanceTolerance=distanceTolerance;}
    get Entity(){return this.entity}
    set Entity(val){this.entity = val}
    get Cursorlocation(){if(this.cursorLocation === undefined) this.cursorLocation = new SPLM.Point3d(); return this.cursorLocation}
    set Cursorlocation(val){this.cursorLocation = val}
    get Viewdirection(){if(this.viewDirection === undefined) this.viewDirection = new SPLM.Vector3d(); return this.viewDirection}
    set Viewdirection(val){this.viewDirection = val}
    get Snaptolocation(){return this.snapToLocation}
    set Snaptolocation(val){this.snapToLocation = val}
    get Activeobjecttype(){return this.activeObjectType}
    set Activeobjecttype(val){this.activeObjectType = val}
    get Hasplanarconfiguration(){return this.hasPlanarConfiguration}
    set Hasplanarconfiguration(val){this.hasPlanarConfiguration = val}
    get Canrelocate(){return this.canRelocate}
    set Canrelocate(val){this.canRelocate = val}
    get Canreorient(){return this.canReorient}
    set Canreorient(val){this.canReorient = val}
    get Distancetolerance(){return this.distanceTolerance}
    set Distancetolerance(val){this.distanceTolerance = val}
};

export default SPLM;